export default "__VITE_ASSET__DyXAC9ke__"